import { useNavigationState } from '@store/hookstate';

import { useQuery } from 'react-query';
import React, { useState } from 'react';
import { InputLabel, MenuItem } from '@material-ui/core';

import { useToast } from '@hooks';
import { Icon } from '@components/BeamOnSidebar/BeamOnSidebar.styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { io } from 'socket.io-client';
import { updateTypeOptions } from '@models/Update.model';
import { getProducts } from '@services/queries/products';
import {
  Container,
  Title,
  Head,
  Button,
  StyledTextArea,
  StyledInput,
  StyledSelect,
  StyledFormControl,
  FormContainer,
} from './AddNotifications.styles';

const AddNotifications = () => {
  const navigationState = useNavigationState();
  const { data } = useQuery('products', () =>
    getProducts({
      pagination: {
        page: 1,
        limit: 20,
      },
    }),
  );
  const { toast } = useToast();
  const [message, setMessage] = useState('');
  const [title, setTitle] = useState('');
  const [notificationType, setNotificationType] = useState('');
  const [productId, setProductId] = React.useState('');
  const allFieldsAreFill =
    !!title && !!message && !!notificationType && !!productId;

  const handleChangeProduct = (event: React.ChangeEvent<{ value: any }>) => {
    setProductId(event.target.value);
  };
  const socket = io(process.env.REACT_APP_API_URL as string, {
    transports: ['websocket', 'polling', 'flashsocket'],
  });

  function submitNewNotification() {
    if (title && message && notificationType && productId) {
      socket.emit('sendNotification', {
        title,
        message,
        type: notificationType,
        productId,
      });
      toast.success('Notification Created');
      setMessage('');
      setNotificationType('');
      setTitle('');
      setProductId('');
      return;
    }
    toast.warn('Fill all fields');
  }
  const handleChangeNotification = (
    event: React.ChangeEvent<{ value: any }>,
  ) => {
    setNotificationType(event.target.value);
  };

  return (
    <Container offsetTop={navigationState.offsetTop.get()}>
      <Head>
        <Title>Add Notifications</Title>
      </Head>

      <FormContainer>
        <StyledInput
          type="text"
          name="name"
          placeholder="Title"
          value={title}
          onChange={e => setTitle(e.target.value)}
        />
        <StyledFormControl variant="outlined">
          <InputLabel id="demo-simple-select-outlined-label">
            Notification Type
          </InputLabel>
          <StyledSelect
            labelId="notificationType-label"
            id="demo-simple-select-outlined"
            value={notificationType}
            onChange={handleChangeNotification}
            label="Notification Type"
          >
            {updateTypeOptions?.map(item => (
              <MenuItem value={item}>{item}</MenuItem>
            ))}
          </StyledSelect>
        </StyledFormControl>
        <StyledFormControl variant="outlined">
          <InputLabel id="demo-simple-select-outlined-label">
            Product
          </InputLabel>
          <StyledSelect
            labelId="productId-label"
            id="demo-simple-select-outlined"
            value={productId}
            onChange={handleChangeProduct}
            label="Product"
          >
            {data?.results.map(item => (
              <MenuItem value={item.id}>{item.name}</MenuItem>
            ))}
          </StyledSelect>
        </StyledFormControl>

        <StyledTextArea
          placeholder="Message"
          value={message}
          onChange={e => setMessage(e.target.value)}
        />
        <Button
          disabled={!allFieldsAreFill}
          onClick={() => submitNewNotification()}
        >
          <Icon>
            <FontAwesomeIcon icon={faBell} color="#fff" size="lg" />
          </Icon>
          Create
        </Button>
      </FormContainer>
    </Container>
  );
};

export { AddNotifications };
